/**
 * ErrorBoundary Component
 */
import React, { Component, ErrorInfo, ReactNode } from 'react';
import { I18nContext } from '@/contexts/I18nContext';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  static contextType = I18nContext;
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null
    });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return <>{this.props.fallback}</>;
      }

      const context = this.context as any;
      const t = context?.t || ((key: string) => key);

      return (
        <div className="error-boundary">
          <div className="error-content">
            <h2>{t('errors.errorOccurred')}</h2>
            <p>{t('errors.unexpectedError')}</p>
            <details style={{ whiteSpace: 'pre-wrap', marginTop: '1rem' }}>
              <summary>{t('errors.details')}</summary>
              {this.state.error && this.state.error.toString()}
            </details>
            <button 
              className="btn btn-primary" 
              onClick={this.handleReset}
              style={{ marginTop: '1rem' }}
            >
              再試行
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;